<template>
  <!-- <div> -->
  <!-- 实训功能正在开发中，选择省份功能隐藏 -->
  <div v-if="domain" class="domain-container">
    <!-- <div
        v-if="domain"
        style="background-color: white;border: .05rem solid #ced9e0;padding: 1rem;padding-bottom: 1.5rem;"
      >
        <div style="margin: .5rem;border-bottom: .05rem solid #ced9e0;padding: 1rem;padding-left: 0;padding-top: 0;">
          选择您将配套学习的省/市财税政策：
        </div>
        <div
          style="display: flex;flex-direction: row; flex-wrap: wrap;padding-left: 1.5rem;padding-right: 1.5rem;padding-left: .5rem;"
        >
          <div
            v-for="(d, index) of domain"
            :key="index"
            @click="chose(d)"
            style="display: flex;margin: .5rem;margin-left: 0;margin-right: 0;"
          >
            <div style="height: 16px; font-size: 16px;line-height: 16px;display: inline-block;">
              <button class="chose-domain">{{ d.name }}</button>
            </div>
          </div>
        </div>
      </div> -->
    <div style="height: 100%;">
      <img class="bg-img" :src="`${assetsUrl}imgs/course/agent-practice.jpg`" />
      <div class="main-content">
        <h1>
          {{
            typeInfo[this.data.classesProp] && typeInfo[this.data.classesProp].title ? typeInfo[this.data.classesProp].title : 'APOIT会计岗位实训'
          }}
        </h1>
        <a class="border-white enter-btn" @click="openWindow()">
          <span class="btn-left"
          >Learn More
            <i class="anticon anticon-arrow-right"></i>
          </span>
          <span class="btn-right">进入学习</span>
        </a>
      </div>
    </div>
    <div
      id="noClasses"
      v-if="!domain"
      style="width: 100%;height: 100%;position: relative;display:none"
    >
      <div
        style="height: 10rem;width:10rem;position: absolute;  left: 0;  right: 0; margin: auto; top: 0;  bottom: 0;"
      >
        <img style="width:10rem;" :src="`${assetsUrl}}imgs/course/staleDated.png`" />
        <!-- <span class="error-mess">{{ errorMess }}</span> -->
      </div>
    </div>
  </div>
  <!-- <div v-if="domainData && !domain" style="height: 100%;">
  <div class="main-content">
    <img class="bg-img" src="{{assetsUrl}}imgs/course/agent-practice.jpg">
    <h1>{{typeInfo[classesProp] && typeInfo[classesProp].title?typeInfo[classesProp].title:'APOIT会计岗位实训'}}</h1>
    <a class="border-white" class="enter-btn" @click="openWindow()">
      <span class="btn-left">Learn More
        <i class="anticon anticon-arrow-right"></i>
      </span>
      <span class="btn-right">进入学习</span>
    </a>
  </div>
</div>
<div id="noClasses" v-if="!(domain || (domainData && domainData.courseId &&  nextUrl))"
  style="width: 100%;height: 100%;position: relative;display:none">
  <div style="height: 10rem;width:10rem;position: absolute;  left: 0;  right: 0; margin: auto; top: 0;  bottom: 0;">
    <img style="width:10rem;" src="{{assetsUrl}}imgs/course/staleDated.png">
    <span class="error-mess">{{errorMess}}</span>
  </div>
</div> -->
  <!-- </div> -->
</template>

<script>
export default {
  name: 'ApoitHyAcc',
  components: {},
  data() {
    return {
      assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
      user: {},
      domain: '',
      domainData: '',
      hytype: 3,
      nextUrl: '',
      typeInfo: {
        '41': { title: 'APOIT建筑施工企业会计岗位实训', time: '2020-8-31' },
        '42': { title: 'APOIT酒店餐饮企业会计岗位实训', time: '2020-8-31' },
        '43': { title: 'APOIT高新技术企业会计岗位实训', time: '2020-9-7' },
        '44': { title: 'APOIT物业管理企业会计岗位实训', time: '2020-9-7' },
        '45': { title: 'APOIT房地产开发企业会计岗位实训', time: '2020-9-21' },
        '46': { title: 'APOIT外贸企业会计岗位实训', time: '2020-9-21' },
        '47': { title: 'APOIT物流运输企业会计岗位实训', time: '2020-9-14' },
        '48': { title: 'APOIT行政事业单位会计岗位实训', time: '2020-9-30' },
        'b0fad761a68469127a3c1472f52dcd99': { title: '新设企业账税一体化岗位实训-天算', time: '2020-9-30' }
      }
    }
  },
  props: {
    planclassesId: {
      type: String,
      required: false,
      default: ''
    },
    classesId: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Object,
      required: false,
      default: null
    }
  },
  created() {
    console.log(this.typeInfo[this.data.classesProp], this.data.classesProp)
    this.domain = this.data.domain
    this.domainData = this.data.domainData
    this.hytype = null
    const type = 'wl'
    if (type === 'wl') {
      // 物流
      this.hytype = 3
    } else if (type === 'fdc') {
      // 房地产
      this.hytype = 4
    } else if (type === 'jd') {
      // 酒店
      this.hytype = 2
    } else if (type === 'wm') {
      // 外贸
      this.hytype = 1
    } else if (type === 'jz') {
      // 建筑
      this.hytype = 0
    } else if (type === 'sc') {
      // 商场
      this.hytype = 5
    } else if (type === 'wy') {
      // 物业
      this.hytype = 6
    } else if (type === 'lxs') {
      // 旅行社
      this.hytype = 7
    } else if (type === 'xz') {
      // 行政事业单位
      this.hytype = 8
    } else if (type === 'gx') {
      // 高新技术企业
      this.hytype = 9
    }
    this.init()
  },
  methods: {
    init() {
      console.log('init', this.data)
      this.nextUrl = this.data.classesUrls ? this.data.classesUrls[0].url : ''
      // document.getElementById("noClasses").style.display = "none";
      this.loadCostAcc() //
    },
    chose(obj) {
      // const para = {
      //   classesId: this.classesId,
      //   planclassesId: this.planclassesId
      // }
    //   this.dialogService
    //     .confirm({
    //       title: '选择确认',
    //       content: '您的学习将配套<i>' + obj.name + '</i> 当地的财税政策，一旦确定则无法更改，请确认您的选择! ',
    //       html: true,
    //       yes: '确定', //
    //       no: '取消'
    //     })
    //     .subscribe(
    //       data => {
    //         this.http
    //           .postHttpWithH('studentWebApi.html?authServerCostAcc', {
    //             domain: obj.code,
    //             classesId: this.classesId,
    //             planclassesId: this.planclassesId
    //           })
    //           .subscribe(result => {
    //             if (result.state == 1) {
    //               this.init()
    //             } else {
    //               document.getElementById('noClasses').style.display = 'block'
    //             }
    //           })
    //       },
    //       error => console.error('Rebirth confirm get no result:', 133222)
    //     )
    },

    loadCostAcc() {
      // const para = {
      //   classesId: this.classesId,
      //   planclassesId: this.planclassesId
      // }
    //   this.http.postHttpWithH('studentWebApi.html?authServerCostAcc', para).subscribe(result => {
    //     this.domainData = result
    //     if (result.state == 1) {
    //       if (result.next_url) {
    //         this.nextUrl = result.next_url
    //         this.domain = null
    //       } else {
    //         this.domain = result.list
    //         if (result.list.length == 1) {
    //           // this.chose()
    //           this.http
    //             .postHttpWithH('studentWebApi.html?authServerCostAcc', {
    //               domain: result.list[0].code,
    //               classesId: this.classesId,
    //               planclassesId: this.planclassesId
    //             })
    //             .subscribe(result => {
    //               if (result.state == 1) {
    //                 this.init()
    //               } else {
    //                 document.getElementById('noClasses').style.display = 'block'
    //               }
    //             })
    //           this.domain = null
    //         }
    //       }
    //     } else {
    //       document.getElementById('noClasses').style.display = 'block'
    //       this.errorMess = result.mess
    //     }
    //   })
    },

    postDomain() {
    //   this.http.postHttpWithH('studentWebApi.html?authService', params).subscribe(result => {
    //     this.http.alertMsg('错误代码', this.errorMess)
    //     const data = result.data
    //     this.info = result.info
    //     if (data.returnCode == '00') {
    //       this.nextUrl = data.next_url
    //       this.domain = null
    //     } else {
    //       this.http.alertMsg('错误代码', data.returnCode)
    //     }
    //   })
    },
    openWindow() {
      // if (this.typeInfo[this.classesProp] && this.typeInfo[this.classesProp].time) {
      //   this.http.alertMsg('上线预告', "实训将于" + this.typeInfo[this.classesProp].time + "温暖上线");
      // } else {
      //   this.http.alertMsg('上线预告', "实训即将温暖上线，敬请期待");
      // }
      if (this.nextUrl) {
        window.open(this.nextUrl)
      } else if (this.typeInfo[this.classesProp] && this.typeInfo[this.classesProp].time) {
        this.http.alertMsg('上线预告', '实训将于' + this.typeInfo[this.classesProp].time + '温暖上线')
      }
    }
  }
}
</script>
<style scoped lang="less">
.border-white {
  border: 1px solid #ffffff;
}
.domain-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.chose-domain {
  background-color: white;
  border: white 0.05rem solid;
  padding: 0.3rem;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  border-radius: 0.02rem;
  font-size: 0.7rem;
}
.chose-domain:hover {
  background-color: #00abff;
  color: white;
}
.main-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  .enter-btn {
    margin: 30px;
    color: #fff;
    border: 1px solid #fff;
    font-size: 18px;
    border-radius: 5px;
    display: inline-block;
    span {
      display: inline-block;
    }
    .btn-left {
      padding: 10px;
    }
    .btn-right {
      background-color: #002693;
      padding: 10px 20px;
      border-radius: 4px;
    }
  }
  h1 {
    color: #fff;
  }
  .bg-img {
    //position: absolute;
    //top: 0;
   // bottom: 0;
   // left: 0;
    // right: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
